import Immutable from 'immutable';

export const FieldRecord = Immutable.Record({
    value: null,
    validationErrors: Immutable.List()
});

export class Field extends FieldRecord {
    getValidationErrors() {
        throw new Error('Method Not Implemented');
    }

    validate() {
        var validationErrors;
        validationErrors = this.getValidationErrors();
        return this.set('validationErrors', validationErrors, true);
    }

    set(key, value, bypassValidations) {
        var record = super.set(key, value);
        if (!bypassValidations) {
            record = record.validate();
        }
        return record;
    }

    setIn(key, value, bypassValidations) {
        var record = super.setIn(key, value);
        if (!bypassValidations) {
            record = record.validate();
        }
        return record;
    }

    hasErrors() {
        return this.validationErrors && this.validationErrors.size > 0;
    }

    getFirstError() {
        if (this.hasErrors()) return this.validationErrors.get(0);
    }
}

export default Field;
